import { Box, useMediaQuery } from "@mui/material";
import Notification from "layouts/Header/HeaderContent/Notification";
import Search from "layouts/Header/HeaderContent/Search";
import Profile from "layouts/Header/HeaderContent/Profile";
import MobileSelection from "./MobileSection";
import React from "react";

function HeaderContent() {
  const matchesXs = useMediaQuery((theme) => theme.breakpoints.down("md"));

  return (
    <>
      {!matchesXs && <Search />}
      {matchesXs && <Box sx={{ width: "100%", ml: 1 }} />}
      <Notification />
      {!matchesXs && <Profile />}
      {matchesXs && <MobileSelection />}
    </>
  );
}

export default HeaderContent;
